import { Directive, ElementRef, Input, OnDestroy, Renderer2 } from '@angular/core';

import { validString } from 'src/app/shared/utilities/types.utils';

@Directive({
	selector: '[ahpTransformNumbersOnly]',
})
export class TransformNumbersOnlyDirective implements OnDestroy {
	private destroyListener: any;
	private allowDecimals = false;

	constructor(private el: ElementRef, private renderer: Renderer2) {
		const { nativeElement } = this.el;
		this.renderer.setAttribute(nativeElement, 'apTransformNumbersOnly', '');

		this.destroyListener = this.renderer.listen(nativeElement, 'keyup', () => {
			const { value } = nativeElement;

			if (!validString(value)) {
				return;
			}

			if (this.allowDecimals) {
				if (/^-?\d+\.?\d*$/.test(value)) {
					return;
				}
			} else if (/^\d*$/.test(value)) {
				return;
			}

			nativeElement.value = value.replace(this.allowDecimals ? /[^0-9\.-]/g : /[^0-9]/g, '');

			const event = document.createEvent('Event');
			event.initEvent('input', false, false);
			nativeElement.dispatchEvent(event);
		});
	}

	@Input()
	set appTransformNumbersOnly(value: boolean) {
		this.allowDecimals = !!value;
	}

	ngOnDestroy() {
		this.destroyListener();
	}
}
